import { Component, Input, OnInit } from '@angular/core';
import { Game } from '../classes/Game';
import { GameService } from '../services/game.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-host-feedback',
  templateUrl: './host-feedback.component.html',
  styleUrls: ['./host-feedback.component.scss']
})
export class HostFeedbackComponent implements OnInit {

  @Input() game: Game;

  stars: number[] = [1, 2, 3, 4, 5];
  standard_positive_tags: string[] = ['Funny', 'Charismatic', 'Professional', 'Clear Instructions', 'Friendly', 'Creative', 'Other'];
  standard_negative_tags: string[] = ['Boring', 'Awkward', 'Confusing', 'Disorganized', 'Unprofessional', 'Rude', 'Unfair Grading', 'Other'];
  available_tags: string[] = [];
  feedback: PlayerFeedback;
  feedback_targets: HostStub[] = [];
  feedback_submitted: boolean = false;
  err: string = '';
  loading = true;

  constructor(private gameService: GameService) { }

  ngOnInit(): void {
    this.getAwaitingFeedback();
  }

  getAwaitingFeedback() {
    this.loading = true;
    this.gameService.checkForFeedbackNeeded(this.game.gameid)
    .pipe(finalize(() => this.loading = false))
    .subscribe((res: HostStub[]) => {
      this.feedback_targets = res;
      if (this.feedback_targets.length) {
        this.feedback = {
          userid: this.feedback_targets[0].userid,
          player_code: this.game.me.player_code,
          stars: null,
          tags: [],
          notes: ''
        }
      }
    });
  }

  toggleTag(tag: string) {
    if (this.feedback.tags.includes(tag)) {
      this.feedback.tags = this.feedback.tags.filter(t => t !== tag);
    } else {
      this.feedback.tags.push(tag);
    }
  }

  selectRating(selectedStar: number) {
    if ((this.feedback.stars > 3 && selectedStar < 4) || this.feedback.stars < 4 && selectedStar > 3) {
      this.feedback.tags = [];
    }
    this.feedback.stars = selectedStar;
    this.available_tags = this.feedback.stars > 3 ? this.standard_positive_tags : this.standard_negative_tags;
  }

  submitFeedback() {
    this.feedback_submitted = true;
    this.err = "";
    this.gameService.sendFeedback(this.game.gameid, this.feedback)
      .subscribe((res: any) => {
        if (this.feedback_targets.length > 1) {
          this.getAwaitingFeedback();
        }
    },
    (err) => {
      this.feedback_submitted = false;
      this.err = "Something went wrong. Please try again.";
    });
  }

}
